import React, {useEffect} from 'react';
import {Button} from '@mui/material';
import {usePageView, useTranslate} from '../../hooks';
import {captureException} from '@sentry/core';
import {ErrorView} from './ErrorView';
import {Link} from '@tanstack/react-router';

export const NotFoundPage = () => {
  const translate = useTranslate();
  usePageView('page_not_found');
  useEffect(() => {
    captureException(
      new Error(`[404] Page not found\n${window.location.href}`),
    );
  }, []);

  return (
    <ErrorView
      title={translate('error.page-not-found.title')}
      subtitle={translate('error.page-not-found.subtitle')}>
      <Link to={'/'}>
        <Button>{translate('error.page-not-found.button')}</Button>
      </Link>
    </ErrorView>
  );
};
